import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37a156f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-title" }
const _hoisted_2 = { class: "detail-content" }
const _hoisted_3 = { class: "temp" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = {
  class: "flex-cen",
  style: {"margin-top":"20px"}
}

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice } from '../data'
import { showCurrentUnit } from '@/util/useYan'
import { isMultiStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  feeTypeDetail: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {



// const columns = [
//   { prop: 'fundFlowName', label: t('主费用名字') },
//   { prop: 'subTypeName', label: t('子费用名字') },
//   { prop: 'proportionAmount', label: t('金额') }
// ]




return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    "model-value": __props.visible,
    "custom-class": "a-detail-f flex",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('详情')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_scrollbar, { height: "500px" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.feeTypeDetail.typeName), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.feeTypeDetail?.orderNum ?? ''), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.feeTypeDetail.feeTypeList, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index,
                  class: "detail-item"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.fundFlowName) + " " + _toDisplayString(item.subTypeName ? '-' + item.subTypeName : '') + "：", 1),
                  _createElementVNode("span", null, _toDisplayString(item.proportionAmount) + " " + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.feeTypeDetail.currencyCode ===
              'KRW')), 1)
                ]))
              }), 128)),
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.feeTypeDetail?.availableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.feeTypeDetail.currencyCode === 'KRW')), 1)
              ]),
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.feeTypeDetail.date)), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})